t = require('views/internal/teacup-with-helpers')('org_prefs_restrict_invites')

module.exports = t.renderable ({ hasRestrictions, hasSlack, slackSelfJoin }) ->
  t.div ->
    t.div '.pop-over-sub-heading', ->
      t.format 'email-domain-restrictions'

    t.form '.form-grid.js-form', ->

      t.div '.form-grid-child-threequarters.u-relative', ->
        t.input '.js-input-restricted.js-autofocus', { type: 'text', placeholder: t.l('add-a-domain-or-address-ellipsis'), style: 'margin-bottom: 6px;' }
        t.span '.spinner.small.hide.js-loading', { style: 'position: absolute; top: 12px; right: 8px; z-index: 2;' }

      t.div '.form-grid-child-quarter', ->
        t.input '.mod-inline-with-text-input.primary.js-form-submit-input', { type: 'submit', value: t.l('add') }

    t.p '.u-bottom.quiet', { style: 'padding: 6px;' }, ->
      t.format 'choose-which-email-domains-and-addresses-can-be-added-to-the-organization-for-example-if-you-only-wanted-users-with-trello-com-email-addresses-to-be-able-to-be-added-to-the-organization-enter-trello-com'

    t.p '.error.u-bottom.js-errors', { style: 'display: none; margin-top: 8px;' }

    t.div '.pop-over-section.js-restriction-list', {
      style: t.stylify({
        'margin-top': '16px'
        'display': if hasRestrictions then 'block' else 'none'
      })
    }, ->
      t.h4 ->
        t.format 'allowed-domains-and-addresses'
      t.ul '.closeable-list.js-list'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/org_prefs_restrict_invites.coffee